module.exports = __webpack_public_path__ + "static/media/bold.a72c64db.svg";